import { RecaptchaVerifier } from 'firebase/auth';
import { useCallback, useRef } from 'react';
import { useAuth } from '@utils/context/auth';

const useRecaptcha = () => {
    const { makeRecaptcha } = useAuth();
    const verifierRef = useRef<RecaptchaVerifier | null>(null);

    const create = useCallback(() => {
        verifierRef.current?.clear();
        verifierRef.current = makeRecaptcha();

        return verifierRef.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // called by parent when unmounting
    const clear = useCallback(() => {
        verifierRef.current?.clear();
        verifierRef.current = null;
    }, []);

    return {
        clear,
        create, // force-create a fresh verifier
        get: () => verifierRef.current ?? create(), // lazy getter
    };
};

export default useRecaptcha;
